import React from 'react'
import styled from '@emotion/styled'
import { useInView } from 'react-cool-inview'

import getVar from '../utils/getVar'

const ObserverHelperBottom = styled('div')`
  position: absolute;
  // bottom: ${props => props.real2vh};
  bottom: var(--real2vh);
  height: 200px;
  width: 11px;
  pointer-events: none;
  z-index: 500;
  background-color: red;
`

const ObserverBottom = ({title, setNewsTitles}) => {
  const real2vh  = getVar('--real2vh')

  const { observe, inView, scrollDirection, entry } = useInView(
    {
      threshold: [0.2, 0.4, 0.6, 0.8, 1],
      trackVisibility: true,
      delay: 100,

      onEnter: ({ scrollDirection }) => {
        if(scrollDirection.vertical === 'down') {
          title ? setNewsTitles(title) : setNewsTitles(null)
          // console.log(title)
          //title ? setIsCurrent(title) : setIsCurrent(null)
          //fieldNotes ? setFieldNotes(fieldNotes) : setFieldNotes(null)
        }
      }
    }
  );


  return (
    <ObserverHelperBottom 
      ref={observe}
      real2vh={real2vh} 
    />
  )
}

export default ObserverBottom